import { render, staticRenderFns } from "./teskManageRD.vue?vue&type=template&id=284251c8&"
import script from "./teskManageRD.vue?vue&type=script&lang=ts&"
export * from "./teskManageRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports